import { actionCreator } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import type { ConsentType, Frequency } from './types';

export type SubmitEmailPreferencesPayload = {
  userId: ArdoqId;
  consent: Record<ConsentType, boolean>;
  digestSettings: { digest: Frequency };
};

export const submittedEmailPreferences =
  actionCreator<SubmitEmailPreferencesPayload>(
    '[EmailPreferencesView] Submitted Email Preferences'
  );

export const submitEmailPreferencesSucceeded = actionCreator(
  '[EmailPreferencesView] Submit Email Preferences Succeeded'
);

export const submitEmailPreferencesFailed = actionCreator(
  '[EmailPreferencesView] Submit Email Preferences Failed'
);
